import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import $ from 'jquery'
import moment from 'moment'
import 'moment/min/locales'
import DataTable from 'datatables.net-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-autofill-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.flash.js'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
import 'datatables.net-colreorder-bs4/css/colReorder.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'
import 'datatables.net-responsive-bs4'
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css'
import 'datatables.net-rowreorder-bs4/css/rowReorder.bootstrap4.css'
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css'
import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import '../../assets/css/vec-datatables.css'
import datatablesConfig from '../../commons/datatables/DatatablesConfig.js'
import jzip from 'xlsx/dist/jszip'
import 'xlsx/dist/xlsx.full.min.js'
import LogoCompany from '../../assets/images/logo-company.png'
import LogoVecFleet from '../../assets/images/logo-vecfleet.png'
import LimpiarFiltros from '../../assets/images/limpiar-filtros.svg'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Switch from "react-switch"
import {FormattedMessage, injectIntl} from 'react-intl';

$.DataTable = DataTable;
window.JSZip = jzip;
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;


class SedeExternaGrid extends Component {
	constructor(props) {
		super(props);

		this.ajaxHandler = new AjaxHandler();

		this.dataService = '/sede-externa';
		this.columnsToPrint = [2,3,4,5,6,7];
		moment.locale('es');

		this.state = {
			redirectTo: null,
			tipo: null,
			editKmEnabled: false,
			maxDifferenceKM: 0,
			canModifyKM: false,
			regionEnabled: false,
			centroCostosEnabled: false,

			dataToExport :{
				nombre : true,
				subregion : true,
				region : true,
				tipo : true,
				activa : true				
			},
			ExportarTodo : true
		}
	}

	handleDataExport(nombre){
		const miState = {...this.state};
		switch (nombre) {
			case "nombre":
				miState.dataToExport.nombre = !miState.dataToExport.nombre;
				break;
			case "region":
				miState.dataToExport.region = !miState.dataToExport.region;
				break;
			case "subregion":
				miState.dataToExport.subregion = !miState.dataToExport.subregion;
				break;
			case "activa":
			miState.dataToExport.activa = !miState.dataToExport.activa;
				break;
			case "tipo":
			miState.dataToExport.tipo = !miState.dataToExport.tipo;
				break;
		}
		this.setState(miState);
	}

	componentDidMount(nextProps, nextState) {
		if(Security.hasPermission('SEDEEXTERNA_LISTAR') && ConfigBusiness.get('sedeExterna.habilitado') === 'true') {
	      this.ajaxHandler.subscribe(this);
				this.initGrid(this.props.intl);
	    } else {
		    	this.setState({
		        redirectTo: '/error'
	      	});
	    }
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
		$('div.tooltip[role="tooltip"]').tooltip('dispose');
		$('div.tooltip[role="tooltip"]').remove();
		if(this.table) this.table.destroy();
	}

	handleNew(event) {
		this.setState({
			redirectTo: this.props.match.url + '/add'
		});
	}

	handleExportExcel() {
		let component = this;
		this.setState({loading:true});
		component.ajaxHandler.fetch('/sede-externa/exportar-excel', {
			method: 'POST',
			body: JSON.stringify({
				colsAExportar: this.state.dataToExport
			})
		}).then(response => {
			if (response.status === 200) {
				return response.blob();
			}
		}).then(fileBlob => {
			let fileUrl = URL.createObjectURL(fileBlob);
			$("<a />", {
				href: fileUrl,
				download: "fleet-sedesExternas.xlsx"
			}).appendTo("body").get(0).click();
		}).catch(() => {
		}).finally(() => {
			component.handleExportCancel();
			this.setState({ loading: false });
		});
	}
	
	handleExportCancel() {
		$('#export_modal').modal('toggle');
	}

	render() {
		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				<div className="row mt-2">
					<div className="col-12">
						<div className="card">
							<div className="card-content collpase show">
								<div className="card-body card-dashboard">
									<div className="container-fluid">
										<div className="row dt-icons">
											<div className="col-6">
												{Security.renderIfHasPermission('SEDEEXTERNA_CREAR', (
												<div className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon" onClick={this.handleNew.bind(this)} data-toggle="tooltip" data-placement="right" title={this.props.intl.formatMessage({ id: 'sedeExternasGrid.button.nuevo.title', defaultMessage: 'Nuevo' })}>
													<i className="ft-plus"></i>
												</div>
												))}
											</div>
											<div className="col-6" id="buttons"></div>
										</div>
									</div>
									<div className="table-responsive">
										<table id="dataTable" className="table nowrap server-side table-hover dataTableMovil" ref="grid" width="100%">
											<tfoot>
												<tr style={{backgroundColor: '#fff'}}>	
													<th className="dt-search-header"><FormattedMessage id="sedeExternasGrid.column.nombre" defaultMessage="Nombre"/></th>
													<th className="dt-search-header"><FormattedMessage id="sedeExternasGrid.column.region" defaultMessage="Región"/></th>
													<th className="dt-search-header"><FormattedMessage id="sedeExternasGrid.column.sub_region" defaultMessage="Sub Región"/></th>
													<th className="dt-search-header"><FormattedMessage id="sedeExternasGrid.column.tipo" defaultMessage="Tipo"/></th>
													<th className="dt-search-header"><FormattedMessage id="sedeExternasGrid.column.activo" defaultMessage="Activo"/></th>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			<div className="modal fade" tabIndex="-1" id="export_modal" role="dialog" aria-labelledby="myModalLabel3">
				<div className="modal-xl modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id="myModalLabel3"><i className="ft-download align-middle icon-modal-title"></i><FormattedMessage id="sedeExternasGrid.exportar_sede_externa" defaultMessage=" Exportar Sedes Externas"/></h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						<div className="modal-body modal-grey modal-mh ovf-x-hidden">
							<div className="row">
								<div className="col-md-12">
									<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
										<div className="form-body">
											<div className="card pull-up">
												<div className="card-content">
													<div className="card-body">
														<h4 className="form-section">
															<i className="la la-columns"></i><FormattedMessage id="sedeExternasGrid.modal.columnas_exportar" defaultMessage=" Columnas a exportar"/>
														</h4>
														<div className="row m-1">
															<div className=" col-md-3">
																<label className="col-md-6 label-control col-form-label" htmlFor="nombre">
																	<FormattedMessage id="sedeExternasGrid.modal.nombre" defaultMessage="Nombre:"/>
																</label>
																<Switch
																	onChange = {(event) => this.handleDataExport("nombre")}
																	checked = {this.state.dataToExport.nombre ? true : false}
																	value={this.state.dataToExport.nombre}
																	id = "nombre"
																	name = "nombre"
																	offColor = "#FF4961"
																	onColor = "#28D094"
																	disabled = {false}
																	className =  "col-md-6 align-middle"										
																/>
															</div>
															<div className=" col-md-3">
																<label className="col-md-6 label-control col-form-label" htmlFor="region">
																	<FormattedMessage id="sedeExternasGrid.modal.region" defaultMessage="Region:"/>
																</label>
																<Switch
																	onChange = {(event) => this.handleDataExport("region")}
																	checked = {this.state.dataToExport.region ? true : false}
																	value={this.state.dataToExport.region}
																	id = "region"
																	name = "region"
																	offColor = "#FF4961"
																	onColor = "#28D094"
																	disabled = {false}
																	className =  "col-md-6 align-middle"										
																/>
															</div>
															<div className=" col-md-3">
																<label className="col-md-6 label-control col-form-label" htmlFor="subregion">
																	<FormattedMessage id="sedeExternasGrid.modal.sub_region" defaultMessage="Sub Región:"/>
																</label>
																<Switch
																	onChange = {(event) => this.handleDataExport("subregion")}
																	checked = {this.state.dataToExport.subregion ? true : false}
																	value={this.state.dataToExport.subregion}
																	id = "subregion"
																	name = "subregion"
																	offColor = "#FF4961"
																	onColor = "#28D094"
																	disabled = {false}
																	className =  "col-md-6 align-middle"														
																/>
															</div>
															
														</div>
														<div className="row m-1">
															<div className=" col-md-3">
																<label className="col-md-6 label-control col-form-label" htmlFor="tipo">
																<FormattedMessage id="sedeExternasGrid.modal.tipo" defaultMessage="Tipo:"/>
																</label>
																<Switch
																	onChange = {(event) => this.handleDataExport("tipo")}
																	checked = {this.state.dataToExport.tipo ? true : false}
																	value={this.state.dataToExport.tipo}
																	id = "tipo"
																	name = "tipo"
																	offColor = "#FF4961"
																	onColor = "#28D094"
																	disabled = {false}
																	className =  "col-md-6 align-middle"
																/>
															</div>
															<div className=" col-md-3">
																<label className="col-md-6 label-control col-form-label" htmlFor="activa">
																	<FormattedMessage id="sedeExternasGrid.modal.activa" defaultMessage="Activa:"/>
																</label>
																<Switch
																	onChange = {(event) => this.handleDataExport("activa")}
																	checked = {this.state.dataToExport.activa ? true : false}
																	value={this.state.dataToExport.activa}
																	id = "activa"
																	name = "activa"
																	offColor = "#FF4961"
																	onColor = "#28D094"
																	disabled = {false}
																	className =  "col-md-6 align-middle"										
																/>
															</div>
														</div>														
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-12 alert alert-info small" role="alert">
											<FormattedMessage id="sedeExternasGrid.modal.information" defaultMessage="Esta acción puede demorar unos minutos."/>
										</div>
									</form>
								</div>
							</div>
						</div>
						<div className="modal-footer modal-grey">
							<button type="button" className="btn btn-default btn-fleet" onClick={this.handleExportExcel.bind(this)} ><i className={this.state.loading ? 'la la-spinner spinner' : 'fa fa-download'}></i><FormattedMessage id="sedeExternasGrid.modal.button.exportar_excel" defaultMessage=" Exportar a Excel"/></button>
							<button type="button" className="btn btn-danger" onClick={this.handleExportCancel} ><i className="fa fa-times-circle"></i><FormattedMessage id="sedeExternasGrid.modal.button.cancelar" defaultMessage=" Cancelar"/></button>
						</div>
					</div>
				</div>
			</div>
			</React.Fragment>
		);
	}

	initGrid() {
		window.scrollTo(0, 0);
		let component = this;

		Promise.all([
			this.getData('/regiones/select'),				
			this.getData('/subregiones/select-all'),
		]).then((data) => {
			let filters = {
				region: data[0] ? data[0] : [],		
				subregion: data[1] ? data[1] : [],	
			};
			let dataToExportCopy = JSON.parse(JSON.stringify(component.state.dataToExport));
			dataToExportCopy.centroCostos = ConfigBusiness.get('bases.centroCostos.habilitado') === 'true' ? true : false;
			component.setState({
				regionEnabled: ConfigBusiness.get('tickets.region.habilitado') === 'true' ? true : false,
				centroCostosEnabled: ConfigBusiness.get('bases.centroCostos.habilitado') === 'true' ? true : false,
				dataToExport: dataToExportCopy
			});

			this.table = $(this.refs.grid).DataTable(
				Object.assign({
					dom: 'r<t><"row mt-2"<"col-4" l><"col-4 text-center" i><"col-4" p>>',
					stateSave: true,
					stateSaveCallback: function(settings, data) {
						localStorage.setItem('DataTables_SedeExternaGrid', JSON.stringify(data));
					},
					stateLoadCallback: function(settings) {
						return JSON.parse(localStorage.getItem('DataTables_SedeExternaGrid'));
					},
					processing: true,
					serverSide: true,
					ajax: {
						type: 'GET',
						url: Config.get('apiUrlBase') + this.dataService,
						headers: {
							'Authorization-Token': localStorage.getItem("token")
						},
						data: function(d) {
							// Si hay ordenamiento, reemplazamos el índice por el nombre de la columna
							if (d.order && d.order.length > 0 && d.columns) {
								d.order.forEach(function(orderObj) {
									var colIdx = orderObj.column;
									var colName = d.columns[colIdx].name || d.columns[colIdx].data;
									if (colName) {
										orderObj.column = colName;
									}
								});
							}
							return d;
						},
						dataSrc: function(response) {
							return response.data;
						},
						error: function(xhr, error, thrown) {},
						cache: false
					},
					initComplete: function(settings) {
						let stateColumns = null;
						const stateData = localStorage.getItem('DataTables_BasesGrid');
						if (stateData) {
						  const parsed = JSON.parse(stateData);
						  stateColumns = parsed && parsed.columns ? parsed.columns : null;
						}

						var sets = settings;
						var index = 0;

						this.api().columns().every(function() {
							var column = this;

							if (sets.aoColumns[index].filterType) {
								if (sets.aoColumns[index].filterType === 'select') {
									var select = $('<select class="btn-dt-filter" required><option value="" selected>'+component.props.intl.formatMessage({ id: 'sedeExternasGrid.filter.placeholder', defaultMessage: 'Buscar...' })+'</option></select>')
										.appendTo($(column.footer()).empty())
										.on('change', function() {
											var val = $(this).val();
											// Solo si la columna existe y es 'activo'
											if (sets.aoColumns && sets.aoColumns[index] && sets.aoColumns[index].name === 'activo') {
												if (val === 'Sí') val = 1;
												else if (val === 'No') val = 0;
											}
											column
												.search(val ? val : '', true, false)
												.draw();
										});
									if (sets.aoColumns && sets.aoColumns[index] && sets.aoColumns[index].name === 'activo') {
										select.append('<option value="1">Sí</option>');
										select.append('<option value="0">No</option>');
									} else if (filters && sets.aoColumns && sets.aoColumns[index] && sets.aoColumns[index].name && filters[sets.aoColumns[index].name]) {
										filters[sets.aoColumns[index].name].map(e => {
											select.append('<option value="' + e.value + '">' + e.label + '</option>');
											return true;
										});
									} else {
										column.data().unique().sort().each(function(d, j) {
											select.append('<option value="' + d + '">' + d + '</option>');
										});
									}
									if (stateColumns && stateColumns[index] && stateColumns[index].search && stateColumns[index].search.search) select.val(stateColumns[index].search.search);
								}
								if (sets.aoColumns[index].filterType === 'input') {
									var input = $('<input type="text" class="btn-dt-filter" placeholder="'+component.props.intl.formatMessage({ id: 'sedeExternasGrid.base.filter.placeholder', defaultMessage: 'Buscar...' })+'" />');
									if (stateColumns && stateColumns[index].search.search) input.val(stateColumns[index].search.search);
									input.appendTo($(column.footer()).empty());
									input.on('keyup change', function() {
										if (column.search() !== this.value) {
											column
												.search(this.value)
												.draw()
												.ajax.reload(null, false);
										}
									});
								}
							}
							index++;
							return '';
						});

						$('tfoot tr').appendTo('thead');
					},
					columns: [{
						title: this.props.intl.formatMessage({ id: 'sedeExternaGrid.select.column.nombre', defaultMessage: 'Nombre' }),
						className: 'all',
						data: 'nombre',
						filterType: 'input'
					}, {
						name: 'region',
						title: this.props.intl.formatMessage({ id: 'sedeExternaGrid.select.column.region', defaultMessage: 'Región' }),
						className: 'all',
						data: 'region',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.id ? data.id : '';
							} else {
								return data && data.nombre ? data.nombre : '';
							}
						},
						filterType: 'select'
						
					}, {
						name: 'subregion',
						title: this.props.intl.formatMessage({ id: 'sedeExternaGrid.select.column.subRegion', defaultMessage: 'Sub Región' }),
						className: 'all',
						data: 'subregion',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.id ? data.id : '';
							} else {
								return data && data.nombre ? data.nombre : '';
							}
						},
						filterType: 'select'
					}, {
						title: this.props.intl.formatMessage({ id: 'sedeExternaGrid.select.column.tipo', defaultMessage: 'tipo' }),
						className: 'all',
						data: 'tipo',
						filterType: 'select'
						
					}, {
						name: 'activo',
						title: this.props.intl.formatMessage({ id: 'sedeExternaGrid.select.column.activo', defaultMessage: 'activa' }),
						className: 'all',
						orderable: false,
						data: 'activo',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data;
							} else {
								return data ? 'Sí' : 'No';
							}
						},
						filterType: 'select'
		            },
					{
						orderable: false,
						data: null,
						className: "text-center all",
						width: '120px',
						render: function(data, type, full, meta) {
							let html =
								(Security.hasPermission('SEDEEXTERNA_VISUALIZAR') ? `
								<button class="action view btn btn-sm btn-icon btn-dt-grid text-success" data-title="Ver" data-togle="tooltip" data-placement="top">
									<i class="fa fa-search fa-xs"></i>
								</button>` : '') +
								(Security.hasPermission('SEDEEXTERNA_EDITAR') ? `
								<button class="action edit btn btn-sm btn-icon btn-dt-grid text-success" data-title="Editar" data-togle="tooltip" data-placement="top">
									<i class="fa fa-pencil fa-xs"></i>
								</button>` : '') 
							return html;
						},
						createdCell: function(td, cellData, rowData, row, col) {
							$(td).find('button').tooltip();
						},
						filterType: 'none'

					}],
					drawCallback: function() {
						$(this).find('.action').on('click', function() {
							let data = component.table.row($(this).parents('tr')).data();
							let redirectTo;
							if ($(this).hasClass('view')) redirectTo = component.props.match.url + '/' + data.id;
							if ($(this).hasClass('edit')) redirectTo = component.props.match.url + '/' + data.id + '/edit';
							
							component.setState({
								redirectTo: redirectTo
							});
						});
					}
				}, datatablesConfig(this.props.intl))

				
			);			

			new $.fn.dataTable.Buttons(this.table, {
				buttons: [{
					name: 'filterReset',
					text: '<img id="filterReset" class="filter-reset" src="'+LimpiarFiltros+'"></i>',
					titleAttr: this.props.intl.formatMessage({ id: 'sedesExternasGrid.filter.reset.restaurar_filtros', defaultMessage: 'Restaurar filtros y ordenamiento' }),
					action: function (e, dt, node, config) {
						var index = 0;
						component.table.columns().every(function() {
							var column = this;

							if (dt.settings()[0].aoColumns[index].filterType) {
								column.search('', true, false);
							}
							index++;
							return null;
						});
						$(dt.table().node()).find('thead tr th *[class$="-filter"]').each((index, element) => {
							$(element).val('');
						});
						dt.table().order([ 0, 'asc' ]);
						dt.ajax.reload();
					}
				}, {
					extend: 'colvis',
					columns: ':not(.no-colvis):not(:empty)',
					name: 'columns',
					text: '<i class="la la-columns"></i>',
					titleAttr: this.props.intl.formatMessage({ id: 'sedesExternasGrid.select.columns.seleccionar_columnas', defaultMessage: 'Seleccionar columnas' })
				}, {
					name: 'exportExcel',
					text: '<i class="ft-upload"></i>',
					titleAttr: this.props.intl.formatMessage({ id: 'sedesExternasGrid.exportar_excel', defaultMessage: 'Exportar a Excel' }),
					action: function (e, dt, node, config) {
						component.setState({
							exportFechaDesde: moment().startOf('year'),
							exportFechaHasta: moment()
						}, () => {
							$('#export_modal').modal({backdrop: 'static'});
						});
					}
				}]
			});

			this.table.buttons(0, null).container().appendTo('#buttons');

			this.table.button('filterReset:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('print:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('columns:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('export:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('exportExcel:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			$('[data-toggle="tooltip"]').tooltip();

			$('.buttons-collection').on("click",function(e){ e.stopPropagation(); 
				if($('.dt-button-collection>.dropdown-menu').css('display')=='none')
					$('.dt-button-collection>.dropdown-menu').css('display','block');
			});
		}).catch(function(error) {
			component.ajaxHandler.handleError(error);
		}).finally(() => {
			component.setState({
				loading: false
			});
		});
	}

	getData(service) {
		let serviceURL = Config.get('apiUrlBase') + service;
		return fetch(serviceURL, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization-Token': localStorage.getItem("token")
			}
		})
		.then(response => {
			return this.ajaxHandler.handleResponseErrorsIsValid(response) ? response.json() : null;
		});
	}

}

export default injectIntl(SedeExternaGrid);
